module.exports = __webpack_public_path__ + "images/305637585466fc5d94eab10d804757c3.svg";